export default "__VITE_ASSET__BbELM2aJ__"